/** Only http(s) / mailto — drop javascript: and other schemes on paste. */
export const isSafeHref = (href) =>
  /^(https?:\/\/|mailto:)/i.test(String(href || '').trim());
